<template>
    <div>
        <slot />
        <b-popover :target="idPopover" triggers="hover" placement="auto" custom-class="box__preview--common">
            <template #title>{{ title }}</template>
            <div class="form-group row mb-0">
                <label class="mw--form" for="shippingCompany">
                    <span class="box__preview--common--title">{{ this.$t('pageCampaign.tabPrize.shippingCompany') }}</span>
                </label>
                <div class="overflow-hidden">
                    <p class="box__preview--common--content">{{ formPreview.delivery_company }}</p>
                </div>
            </div>

            <div class="form-group row mb-0">
                <label class="mw--form" for="trackingNumber">
                    <span class="box__preview--common--title">{{ this.$t('pageCampaign.tabPrize.trackingNumber') }}</span>
                </label>
                <div class="overflow-hidden">
                    <p class="box__preview--common--content">{{ formPreview.tracking_number }}</p>
                </div>
            </div>

            <div class="form-group row mb-0">
                <label class="mw--form" for="expectedNumberOfBoxesInStock">
                    <span class="box__preview--common--title">{{ this.$t('pageCampaign.tabPrize.expectedNumberOfBoxesInStock') }}</span>
                </label>
                <div class="overflow-hidden">
                    <p class="box__preview--common--content">{{ formPreview.number_of_boxes_to_be_stocked }}</p>
                </div>
            </div>

            <div class="form-group row mb-0">
                <label class="mw--form" for="expirationDate">
                    <span class="box__preview--common--title">{{ this.$t('pageCampaign.tabPrize.expirationDate') }}</span></label
                >
                <div class="overflow-hidden">
                    <p class="box__preview--common--content">{{ formPreview.expiration_date }}</p>
                </div>
            </div>

            <div class="form-group row mb-0">
                <label class="mw--form" for="storageWarehouse">
                    <span class="box__preview--common--title">{{ this.$t('pageCampaign.tabPrize.storageWarehouse') }}</span></label
                >
                <div class="overflow-hidden">
                    <p class="box__preview--common--content">{{ formPreview.storage_warehouse?.value ?? '' }}</p>
                </div>
            </div>

            <div class="form-group row mb-0">
                <label class="mw--form" for="locatorNumber">
                    <span class="box__preview--common--title">{{ this.$t('pageCampaign.tabPrize.locatorNumber') }}</span></label
                >
                <div class="overflow-hidden">
                    <p class="box__preview--common--content">{{ formPreview.locator_number }}</p>
                </div>
            </div>
        </b-popover>
    </div>
</template>

<script>
export default {
    name: 'PopoverPreviewInfo',
    components: {},
    props: {
        id: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        dataPreview: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            idPopover: this.id,
            formPreview: this.dataPreview
        };
    },
    watch: {
        dataPreview: {
            handler(newDataPreview) {
                this.formPreview = newDataPreview;
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss"></style>
